export default {
  type: "object",
  properties: {
    full_size: {
      type: "string",
      description: "URL of large image",
      example: "https:..bodyHeight.jpg"
    },
    small: {
      type: "string",
      description: "URL of small image",
      example: "https:..bodyHeight.jpg"
    }
  }
};
